export default [

     {
          path: '/risk-category',
          name: 'RiskCategory',
          component: () => import("@/views/Page/RiskCategory/RiskCategory.vue"),
           meta: {
               title: 'RiskCategory',
          },
     }
];